export default (state = [], action) => {
    switch (action.type) {
        case 'FETCH_POSITION':
            return action.payload;
        default:
            return state;
    }
};
